import { action } from 'mobx';
import { FormBase } from 'core/components';
import { BaseViewStore } from 'core/stores';
import { formInvalidate } from 'core/utils';
import moment from 'moment';
import { sourceOfChange } from 'common/constants';
import _ from 'lodash';
import { BaasicDropdownViewStore } from 'common/stores';

class LookupEditViewStore extends BaseViewStore {
	// Used for notifications (create, edit)
	itemName = '';

	form = new FormBase({
		onSuccess: async () => {
			const mode = this.getEditMode();
			if (mode === 'edit') {
				await this.updateLookup();
			} else if (mode === 'create') {
				await this.createLookup();
			}
		},
	});

	format = null;

	constructor(rootStore, { modalParams }) {
		super(rootStore);
		this.modalParams = modalParams;
		this.listStore = rootStore.lookupViewStore.listStore;
		let locale = window.navigator.userLanguage || window.navigator.language;
		moment.locale(locale);
		let localeData = moment.localeData();
		this.format = localeData.longDateFormat('L');
		this.initialize();
	}

	getEditMode() {
		const queryParams = this.rootStore.routerStore.routerState.queryParams;
		return queryParams['editId'] !== undefined ? 'edit' : queryParams['create'] !== undefined ? 'create' : 'none';
	}

	@action async initialize() {
		this.form.setForm(this.form);
		this.itemName = this.modalParams.data.editView.itemName;
		this.form.reset();
		this.form.init(this.modalParams.data.editView.initFields);
		this.form.each(field => {
			if (field.name == 'length') {
				field.set('value', '');
			}
		});

		if (this.getEditMode() === 'edit') {
			await this.getLookup();
		} else {
			this.form.clear();
			await this.initializeDropdowns(
				this.modalParams.data.selectedLookup.parameters.fields.filter(field => field.isDropdown)
			);
		}
	}

	@action async getLookup() {
		this.suspend();
		let parameters = this.modalParams.data.selectedLookup.parameters;
		let options = parameters.embed ? { embed: parameters.embed } : null;
		await this.listStore.getLookup(parameters.lookup, options);
		this.form.updateForm(this.listStore.item);
		await this.initializeDropdowns(parameters.fields.filter(field => field.isDropdown));
		this.resume();
	}

	@action
	initializeDropdowns = async dropdownFields => {
		await Promise.all(
			dropdownFields.map(async field => {
				let updateValue = {
					value: _.get(this.listStore.item, `${field.path.split('.')[0]}.${'id'}`),
					label: _.get(this.listStore.item, `${field.path.split('.')[0]}.${'name'}`),
				};

				this.form.$(field.key).dropdownStore = new BaasicDropdownViewStore();
				await this.form.$(field.key).dropdownStore.initialize({
					store: field.store,
					value: this.getEditMode() === 'edit' ? updateValue : null,
					field: this.form.$(field.key),
					lookupRoute: field.lookupRoute,
				});
			})
		);
	};

	@action async updateLookup() {
		this.suspend();
		try {
			let updateValues = this.form.values();
			await this.listStore.updateLookup(
				{
					id: this.rootStore.routerStore.routerState.queryParams.editId,
					...updateValues,
				},
				this.modalParams.data.selectedLookup.parameters.lookup,
				sourceOfChange.editLookup + ' - ' + this.modalParams.data.selectedLookup.parameters.lookup
			);
			this.rootStore.notificationStore.success([
				'LOOKUPUPDATE.LOOKUP',
				{
					name: updateValues.name ? updateValues.name : updateValues[Object.keys(updateValues)[0]],
					lookup: this.itemName,
				},
			]);
			await this.modalParams.data.findLookup();
			this.modalParams.close();
		} catch (err) {
			formInvalidate({ form: this.form, err });
		}
		this.resume();
	}

	@action.bound
	createLookup = async () => {
		this.suspend();
		try {
			let updateValues = this.form.values();
			await this.listStore.createLookup(
				{
					...updateValues,
				},
				this.modalParams.data.selectedLookup.parameters.lookup,
				sourceOfChange.createLookup + ' - ' + this.modalParams.data.selectedLookup.parameters.lookup
			);
			this.rootStore.notificationStore.success([
				'LOOKUPCREATE.LOOKUP',
				{
					name: updateValues.name ? updateValues.name : updateValues[Object.keys(updateValues)[0]],
					lookup: this.itemName,
				},
			]);
			await this.modalParams.data.findLookup();
			this.modalParams.close();
		} catch (err) {
			formInvalidate({ form: this.form, err });
		}
		this.resume();
	};
}

export default LookupEditViewStore;



// WEBPACK FOOTER //
// ./src/modules/lookup/stores/LookupEditViewStore.js